import React, { useState } from "react";
import { Box, Container } from "@mui/material";
import BackgroundImageCst from "@components/BackgroundImageCst";
import HeroCst from "@components/HeroCst";
import AddEditFormCst from "@components/AddEditFormCst";
import { useFetchDetail, usePostDetail } from "@hooks/useFetchDetail";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Breadcrumb from "@components/Breadcrumb";
import { useTranslation } from "react-i18next";
import { ServicesURL } from "@utils/utilsApi";
import { PagesID } from "@utils/utilsConfigurations";
import ModalConfirmsCst from "@components/ModalConfirmsCst";
import { StatusEnum } from "@components/ModalConfirmsCst/types";
import AnimationFadeIn from "@components/AnimationFadeIn";
import { isTrueValue } from "@utils/utilsValidators";

const AddAttribute: React.FC = () => {
  const { t } = useTranslation(["attributes-page"]);
  const { id } = useParams();
  const navigate = useNavigate();
  const [openToast, setOpenToast] = useState<{
    s: StatusEnum;
    message: string;
    description?: string;
  }>();

  const { columns } = useFetchDetail(
    ServicesURL.attributes,
    undefined,
    PagesID["corporate.attributes"],
  );

  const { trigger: triggerPostGroups } = usePostDetail(ServicesURL.attributes);

  const onSubmit = async (inputForm: any) => {
    const explore = isTrueValue(inputForm["exploreCarousel"]) || false;
    const forY = isTrueValue(inputForm["forYou"]) || false;
    const order = Number(inputForm["orderParam"]);
    let objToSend: any = {
      attribute: inputForm["attribute"] || "",
      corporateId: Number(id),
      forYou: forY,
      exploreCarousel: explore,
      orderParam: order,
    };
    try {
      await triggerPostGroups(objToSend);
      setOpenToast({ s: StatusEnum.OK, message: "" });
    } catch (error) {
      console.error(error);
      setOpenToast(undefined);
    }
  };

  return (
    <AnimationFadeIn>
      <BackgroundImageCst
        customWidth={"100%"}
        customHeight={"603px"}
        image="section-corp-attributes.jpg"
        position={"absolute"}
        fullpage={true}
      />
      <Breadcrumb />
      <Container
        maxWidth={"xxl"}
        sx={{
          position: "relative",
          zIndex: 1,
        }}
      >
        <HeroCst title={t("add.hero-title")} description={""} />
        {columns && (
          <Box
            sx={{
              mt: "25px",
            }}
          >
            <AddEditFormCst
              columns={columns}
              onSubmit={onSubmit}
              backButton={() => {
                navigate(`/corporate/${id}/detail/attributes`);
              }}
            />
          </Box>
        )}
        <ModalConfirmsCst
          open={!!openToast}
          title={t("outcome-item", { ns: "modal" })}
          description={t("outcome-item", { ns: "modal" })}
          onCallBackClosed={() => {
            navigate(`/corporate/${id}/detail/attributes`);
          }}
          onActionConfirmed={() => {
            navigate(`/corporate/${id}/detail/attributes`);
          }}
          status={openToast}
        />
      </Container>
    </AnimationFadeIn>
  );
};

export default AddAttribute;
